import type {Appareil} from "@mytour/shared";
import {z} from "zod";

const appareilsRecapSchema = z
  .array(
    z.object({
      appareilType: z.string(),
      appareilTypeCustom: z.string().optional(),
      appareilEmplacement: z.string(),
      combustible: z.string(),
      conduitType: z.string(),
      natureIntervention: z.array(z.string()),
      nettoyageAction: z.string(),
      nettoyageOutil: z.string(),
      tirage: z.enum(["conforme", "nonConforme", "nonVerifie"]),
      attestationVacuite: z.boolean(),
      remarques: z.string().optional(),
    })
  )
  .nonempty();

export function isApplianceRecapAvailable(appareils: unknown): appareils is Appareil[] {
  return appareilsRecapSchema.safeParse(appareils).success;
}
